import { render } from "./BaseLoader.vue?vue&type=template&id=49c1eb46"
const script = {}

import "./BaseLoader.vue?vue&type=style&index=0&id=49c1eb46&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__